import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

import ContactUsCard from "../ContactUsCard/ContactUsCard";
import { defaultBreadcrumbContacts } from "./ContactUs.helpers";
import Styles from "./ContactUs.styles";
import { ContactUsProps as Props } from "./ContactUs.types";
import Breadcrumb from "components/global/Breadcrumb/Breadcrumb";
import Footer from "components/global/Footer/Footer";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import useI18n from "hooks/useI18n";
import { sanitizeQueryParams } from "utils/common.utils";

import ChevronLeftSVG from "../../../../public/assets/images/arrow-left.svg";

const ContactUs: React.FC<Props> = props => {
  const { contactUS: t } = useI18n();
  const { query } = useRouter();
  const { fromErrorScreen } = sanitizeQueryParams(query);

  const renderCards = (
    <div className="ContactUs__content__body">
      <ContactUsCard
        serviceName="Whatsapp"
        serviceValue="0986117316"
        btnText={t.goToWP}
        link="https://wa.link/cfdqis"
      />
      <ContactUsCard
        serviceName={t.homeNumber}
        serviceValue="1800263347"
        btnText={t.call}
        link="tel:1800263347"
      />
      <ContactUsCard
        serviceName={t.email}
        serviceValue="servicioclientefondos@anefi.com.ec"
        btnText={t.email}
        link="mailto:servicioclientefondos@anefi.com.ec"
      />
    </div>
  );

  const renderFromProfile = (
    <>
      <h1 className="ContactUs__content__title">{t.title}</h1>
      <p className="ContactUs__content__subTitle">{t.subtitle}</p>
      {renderCards}
    </>
  );

  const renderFromError = fromErrorScreen ? (
    <section className="ContactUs__content__mainError">
      <div>
        <h1 className="ContactUs__content__title">{t.titleOTP}</h1>
        {/* TODO: add number */}
        <p className="ContactUs__content__subTitle">
          {t.subTitleOTP} {` xxxxxx975`}
        </p>
      </div>
      <div>
        <p className="ContactUs__content__subTitleError">{t.subTitleBottom}</p>
        {renderCards}
      </div>
    </section>
  ) : (
    renderFromProfile
  );

  return (
    <Styles className="ContactUs">
      <header className="ContactUs__header">
        <Navbar />
        <div className="ContactUs__main__header">
          <Breadcrumb items={defaultBreadcrumbContacts} />
        </div>
      </header>
      <main className="ContactUs__main">
        <div className="ContactUs__layout">
          <ProfileNavigation className="ContactUs__profile-navigation" />
          <section className="ContactUs__content">
            <div className="ContactUs__content__header">
              <Link href="/profile/support" passHref>
                <div className="ContactUs__content__backSVG">
                  <ChevronLeftSVG />
                </div>
              </Link>
            </div>
            {renderFromError}
          </section>
        </div>
      </main>
      <footer className="ContactUs__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ContactUs.defaultProps = {};

export default ContactUs;
